<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive table-desi table-product">
                        <v-data-table-server
                            class="table table-1d all-package blogGrid"
                            v-model:items-per-page="itemsPerPage"
                            :search="search"
                            :headers="showHeaders"
                            :items-length="pagination.total"
                            :items="dataGrid"
                            :loading="loading"
                            item-value="name"
                            @update:options="getGrid"
                        >
                            <template v-slot:thead>
                                <tbody>
                                    <tr>
                                        
                                        <td v-if="selectedHeaders.includes('id')">
                                            <v-text-field v-model="id" hide-details placeholder="Search id..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('user_name')">
                                            <v-text-field v-model="user_name" hide-details placeholder="Search user..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('article_name')">
                                            <v-text-field v-model="article_name" hide-details placeholder="Search article..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('comment')">
                                            <v-text-field v-model="comment" hide-details placeholder="Search comment..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('assessment')">
                                            <v-rating
                                                v-model="assessment"
                                                color="orange-darken-2"
                                                density="compact"
                                                background-color="grey-lighten-2"
                                            ></v-rating>
                                        </td>
                                        <td v-if="selectedHeaders.includes('updated_at')">
                                            <v-text-field v-model="updated_at" hide-details placeholder="Search updated at..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('has_media')"></td>
                                        <td v-if="selectedHeaders.includes('actions')"></td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-slot:item.article_name="{ item }">
                                <span>{{ item.article_name.es }}</span>
                            </template>
                            <template v-slot:item.updated_at="{ item }">
                                <span>{{ getFormatUpdatedAt(item.updated_at)  }}</span>
                            </template>
                            <template v-slot:item.assessment="{ item }">
                                <v-rating
                                    v-model="item.assessment"
                                    color="orange-darken-2"
                                    density="compact"
                                    size="small"
                                    readonly
                                ></v-rating>
                            </template>
                            <template v-slot:item.has_media="{ item }">
                                <v-icon v-if="item.media_count > 0" color="success">mdi-paperclip</v-icon>
                                <v-icon v-else color="grey">mdi-minus</v-icon>
                            </template>

                            <template v-slot:item.active="{ item }">
                                <v-checkbox class="ma-2"
                                    v-model="item.active"
                                    readonly
                                ></v-checkbox>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                
                                <!-- <v-btn color="primary" class="elevation-0" icon variant="plain" @click="edit(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn> -->
                                <div style="display: flex; justify-content: center; align-items: center; gap: 10px;">
                                    <article-comment-status-component
                                      :items="itemsArticleCommentStatus"
                                      :selected="getSelected(item)"
                                      :selectedItem="item"
                                      :saving="isStatusSaving(item)"
                                      :saved="isStatusSaved(item)"
                                      :showSaveButton="true"
                                      @update:selected="(value) => handleStatusChange(value, item)"
                                      @save:selected="(value) => handleStatusChange(value, item)"
                                    />
                                    <div style="display: flex; justify-content: center; align-items: center;">
                                        <v-btn color="success"   class="elevation-0" icon variant="plain" @click="editItem(item)"><v-icon>mdi-text-box-edit-outline</v-icon></v-btn>
                                        <v-btn color="error"   class="elevation-0" icon variant="plain" @click="openDeleteDialog(item)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                                    </div>
                                </div>
                                
                                <v-dialog v-model="dialogDelete" max-width="600px">
                                    <v-card>
                                        <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                        <v-card-text> Are you sure you want to delete the comment '{{ selectedItem.comment }}'? </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="red"   text @click="dialogDelete = false">Cancel</v-btn>
                                            <v-btn color="green" text @click="deleteItem(selectedItem)">Delete</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-data-table-server>
                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import ArticleCommentStatusComponent from '@/components/article_comments/articleCommentStatusComponent.vue'
import { 
  deleteArticleCommentService, 
  getGridArticleCommentService, 
  articleCommmentsStatusChangeService,
  getArticleCommmentsStatusListService
} from '@/services/ArticleCommentService'

const router = useRouter()

const itemsArticleCommentStatus = ref([])

const dataGrid = ref([])

const pagination = reactive({
  from: 0,
  to: 0,
  total: 0,
  current: 1,
  lastPage: 0
})

const itemsPerPage = ref(10)
const selectedHeaders = ref(['user_name', 'article_name', 'comment', 'assessment', 'updated_at', 'has_media', 'actions'])

const headers = [
  { title: 'User', align: 'center', sortable: true, key: 'user_name' },
  { title: 'Article', align: 'center', sortable: true, key: 'article_name' },
  { title: 'Comment', align: 'center', sortable: true, key: 'comment' },
  { title: 'Assessment', align: 'center', sortable: true, key: 'assessment' },
  { title: 'Updated at', align: 'center', sortable: true, key: 'updated_at' },
  { title: 'Attached', align: 'center', sortable: false, key: 'has_media' },
  { title: 'Actions', align: 'center', sortable: false, key: 'actions' },
]

const loading = ref(true)

// Filtros search
const id = ref('')
const user_name = ref('')
const article_name = ref('')
const comment = ref('')
const assessment = ref(0)
const updated_at = ref('')

const search = ref('')

const selectedItem = ref(null)
const dialogDelete = ref(false)
const messageError = ref('')
const typeOfMessage = ref('')
const statusSavingById = ref({})
const statusSavedById = ref({})

watch([id, user_name, article_name, comment, assessment, updated_at], () => {
  search.value = String(Date.now())
})

const showHeaders = computed(() => {
  return headers.filter(h => selectedHeaders.value.includes(h.key))
})

const getSelected = (item) => {
  const status = itemsArticleCommentStatus.value.find(status => status.id == item.status_id)
  return status ? status : itemsArticleCommentStatus.value.find(status => status.name == 'Pendiente')?.name
  
}

function setStatusSaving(id, saving) {
  statusSavingById.value = {
    ...statusSavingById.value,
    [id]: saving
  }
}

function setStatusSaved(id, saved) {
  statusSavedById.value = {
    ...statusSavedById.value,
    [id]: saved
  }
}

function isStatusSaving(item) {
  return !!statusSavingById.value[item.id]
}

function isStatusSaved(item) {
  return !!statusSavedById.value[item.id]
}

async function handleStatusChange(newStatus, item) {
  setStatusSaved(item.id, false)
  setStatusSaving(item.id, true)
  try {
    await articleCommmentsStatusChangeService(item.id, newStatus.id)
    item.status_id = newStatus.id
    item.status_name = newStatus.name
    setStatusSaved(item.id, true)
    setTimeout(() => setStatusSaved(item.id, false), 1500)
  } catch (error) {
    messageError.value = 'Error! No se pudo guardar el estado del comentario.'
    typeOfMessage.value = 'error'
    setTimeout(() => (messageError.value = ''), 6000)
  } finally {
    setStatusSaving(item.id, false)
  }
}

function getFormatUpdatedAt(updatedAt) {
  if (!updatedAt) return '-'

  let dateValue = updatedAt

  if (typeof updatedAt === 'object') {
    if (typeof updatedAt.timestamp === 'number') {
      // Symfony can return epoch seconds in timestamp.
      dateValue = updatedAt.timestamp * 1000
    } else if (updatedAt.date) {
      dateValue = updatedAt.date
    }
  }

  const date = new Date(dateValue)
  if (Number.isNaN(date.getTime())) return '-'

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

function openDeleteDialog(item) {
  selectedItem.value = item
  dialogDelete.value = true
}

function editItem(item) {
  router.push({ name: "edit_product_comment",  params: { id: item.id } })
}

async function getGrid({ page = 1, itemsPerPage = 10, sortBy = [], search = '' } = {}) {
  loading.value = true
  try {
    const data = await getGridArticleCommentService({
      page: page || pagination.current,
      itemsPerPage: itemsPerPage || itemsPerPage.value,
      sortBy: sortBy || [],
      id: id.value,
      user_name: user_name.value,
      article_name: article_name.value,
      comment: comment.value,
      assessment: assessment.value,
      updated_at: updated_at.value
    })

    dataGrid.value = data.data || []
    pagination.from = data.from
    pagination.to = data.to
    pagination.total = data.total
    pagination.current = data.current_page
    pagination.lastPage = data.last_page

  } catch (error) {
    console.error('Error fetching grid:', error)
  } finally {
    loading.value = false
  }
}

function newItem(item) {
  router.push({ name: "add_vendor" })
}

function edit(item) {
  router.push({ path: "edit_vendor/" + item.id })
}

async function deleteItem(item) {
  try {
    const response = await deleteArticleCommentService(item.id)
    
    if (response.error) {
      messageError.value = response.message
      typeOfMessage.value = 'error'
    } else {
      messageError.value = response.message
      typeOfMessage.value = 'success'
    }
  } catch (error) {
    messageError.value = 'Error! El registro no se ha eliminado.'
    typeOfMessage.value = 'error'
  }

  setTimeout(() => (messageError.value = ''), 10000)

  await getGrid({ page: pagination.current, itemsPerPage: itemsPerPage.value })
  dialogDelete.value = false
}

onMounted(async () => {
  getArticleCommmentsStatusListService()
  .then(data => {
    itemsArticleCommentStatus.value = data
    if (itemsArticleCommentStatus.value.length > 0) {
      getGrid({ page: pagination.current, itemsPerPage: itemsPerPage.value })
    }
  })
  .catch(err => {
    console.error('Error al obtener estados:', err)
  });

  /* let apiURL = process.env.VUE_APP_URL_API_BASE + '/admin/article-comment/status-list'
  //const response = await useFetch('/admin/article-comment/status-list')
  await axios({
      url: apiURL,
      method: 'GET',
      data: {},
      responseType: 'json'
  }).then((response) => {
      if (response.data) {
          itemsArticleCommentStatus.value = response.data
          getGrid({ page: pagination.current, itemsPerPage: itemsPerPage.value })
      }
  }) */
}); 
</script>


<style></style>
